/** ALFX Locations 
 *    - Controller logic
 * 
*/
import { associatedItemsForEntities, firstItemWithValueForKey } from "./wpn2Model.js";


export function feedbackOptionsForKey(key) {
    switch (key) {
        case 'sound_source':
            return [
                { value: "unknown", title: "Unknown" },
                { value: "suspectedLeak", title: "Suspected Leak" },
                { value: "confirmedLeak", title: "Confirmed Leak" },
                { value: "repairedLeak", title: "Repaired Leak" },
                { value: "usage", title: "Usage" },
                { value: "electricalInterference", title: "Electrical Interference" },
                { value: "irrigation", title: "Irrigation" },
                { value: "hydrant", title: "Hydrant" },
                { value: "valve", title: "Valve" },
                { value: "meter", title: "Meter" },
                { value: "pump", title: "Pump" },
                { value: "prv", title: "PRV" },
                { value: "other", title: "Other" }
            ];

        case 'leak_type':
            return [
                { value: "unknown", title: "Unknown" },
                { value: "pinhole", title: "Pinhole" },
                { value: "hole", title: "Hole"},
                { value: "corrosionPit", title: "Corrosion Pit" },
                { value: "crack", title: "Crack" },
                { value: "joint", title: "Joint" },
                { value: "seal", title: "Seal" },
                { value: "stem", title: "Stem" },
                { value: "gasket", title: "Gasket" },
                { value: "damage", title: "Damage" },
                // Move to asset type
                { value: "valve", title: "Valve" },
                { value: "end", title: "End" },
                { value: "other", title: "Other" }
            ]

        default:
            break;
    }
    return [];
}

// ALFX_TODO: Fix this function
export function getFeedbackForItem(item, dbData) {
    // Find any feedback items that have 'item' as their parent
    var feedbackItem = firstAssociatedItemForEntities(['Feedback'], dbData.all, item, false, false, true, false);
    if (Object.keys(feedbackItem).length == 0) {
        // Create a feedback item
        feedbackItem = createdItemWithEntity('Feedback', item?.name, item?.entity, item, dbData);
    }
    console.log("Feedback item: ", feedbackItem);
    return feedbackItem;
}

export function correlationsByRecordingDate(locationItem, alfx_data) {
    // ALFX_TODO: corrItems has duplicates
    const corrItems = associatedItemsForEntities(
        ['Correlation'], alfx_data, locationItem, true, false, false, false
    );
    const grouped = {};
    for (const item of corrItems) {
        if (!item.rec_date) continue;
        if (!grouped[item.rec_date]) {
            grouped[item.rec_date] = [];
        }
        grouped[item.rec_date].push(item);
    }
    console.log("Grouped correlations: ", grouped);
    return grouped;
}
